export default "__VITE_ASSET__DLuHQwv1__"